import { gql } from "apollo-boost";
import { fragments } from "../queries/JobServices";

export default gql`
  mutation ConvertServiceMutation($id: ID!, $input: ServiceInput!) {
    convertToNewService(id: $id, input: $input) {
      ...JobService
    }
  }
  ${fragments.service}
`;



// WEBPACK FOOTER //
// ./src/mutations/ConvertToNewService.js